import { render, staticRenderFns } from "./ManufacturingNew.vue?vue&type=template&id=54b8a85c&"
import script from "./ManufacturingNew.vue?vue&type=script&lang=js&"
export * from "./ManufacturingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports